import { ValidationCallback } from '~/types/types'

export const email: ValidationCallback = (value: unknown, params?: unknown, customMessage?: string) => {
  const reg = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  const res = reg.test((`${value}`).toLowerCase())
  return value === '' || res || (customMessage || 'Неверный формат email адреса')
}
